import { render, staticRenderFns } from "./LfGridPersistedComponent.vue?vue&type=template&id=5b526897"
import script from "./LfGridPersistedComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./LfGridPersistedComponent.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b526897')) {
      api.createRecord('5b526897', component.options)
    } else {
      api.reload('5b526897', component.options)
    }
    module.hot.accept("./LfGridPersistedComponent.vue?vue&type=template&id=5b526897", function () {
      api.rerender('5b526897', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/grids/LfGrid/LfGridPersistedComponent.vue"
export default component.exports